import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxNciDictionaryItem} from "./dx-nci-dictionary-item";


@jsonObject
export class DxNciDictionary {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false })
  private _ident: string;

  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  @jsonMember({name: "hierarchical", constructor: Boolean, emitDefaultValue: false, isRequired: false })
  private _isHierarchical: boolean = false;

  @jsonMember({name: "sortField", constructor: String, emitDefaultValue: false, isRequired: false })
  private _sortField: string;

  @jsonArrayMember(DxNciDictionaryItem, {name: "elements", emitDefaultValue: false, isRequired: false })
  protected _elements: DxNciDictionaryItem[] = [];

  /**
   * Индекс элементов справочника (Для более удобного поиска элементов).
   * @name _elementIndex
   * @type {Map<number, DxNciDictionaryItem>}
   */
  private readonly _elementIndex: Map<number, DxNciDictionaryItem>;

  /** Поисковая строка - конкатенация наменований элементов. */
  private _searchString: string;

  constructor() {
    this._elementIndex = new Map();
    this._searchString = '';
  }

  public fillIndex(): void {
    if(!this.isEmpty) {
      const names: string[] = [];
      this._elements.forEach(item => {
        this._elementIndex.set(item.id, item);
        names.push(item.name);
      });
      this._searchString = names.join(', ');
    }
  }

  public addItem(item: DxNciDictionaryItem): void {
    this._elements.push(item);
    this._elementIndex.set(item.id, item);
  }

  public get elementIndex(): Map<number, DxNciDictionaryItem> {
    return this._elementIndex;
  }

  public get isEmpty(): boolean {
    return !(this._elements && this._elements.length > 0);
  }

  get searchString(): string {
    return this._searchString;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get isHierarchical(): boolean {
    return this._isHierarchical;
  }

  set isHierarchical(value: boolean) {
    this._isHierarchical = value;
  }

  get sortField(): string {
    return this._sortField;
  }

  set sortField(value: string) {
    this._sortField = value;
  }

  get elements(): DxNciDictionaryItem[] {
    return this._elements;
  }

  set elements(value: DxNciDictionaryItem[]) {
    this._elements = value;
  }
}
